import { Auth } from 'aws-amplify';
import axios from 'axios';
import config from './config';
import secureStorage from './secureStorage';

const baseURL = process.env.REACT_APP_APPLICANTMANAGEMENTAPI ? process.env.REACT_APP_APPLICANTMANAGEMENTAPI : config.applicantManagementAPI;

export const instance = axios.create({
    baseURL,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Cache-Control": "no-cache"
    }
});

const redirectToLogin = async () => {
    try {
        await Auth.signOut();
    } catch (_) {
        // ignore sign-out errors
    }
    secureStorage.clear();
    window.onbeforeunload = null;
    window.location.href = "/";
};

instance.interceptors.request.use(
    async config => {
        try {
            const session = await Auth.currentSession();
            const token = session.getAccessToken().getJwtToken();
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
        } catch (sessionError) {
            await redirectToLogin();
            return Promise.reject(sessionError);
        }

        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    response => response,
    async error => {
        if (error?.response?.status === 401) {
            await redirectToLogin();
        }
        return Promise.reject(error);
    }
);

export const instanceWithoutToken = axios.create({
    baseURL,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Cache-Control": "no-cache"
    }
});
